import { TestContext } from 'yup'
import { CountryCodes } from 'constants/Countries'
import { getTranslation } from 'utils/translations'
import { AccountContactFormKeys } from './constants'

export const GovernmentIdPattern = {
  [CountryCodes.US]: '^(?!000|666)[0-8]\\d{2}-?(?!00)\\d{2}-?(?!0000)\\d{4}$',
}

export const PERSON_REGION_KEYS: string[] = [
  AccountContactFormKeys.NATIONALITY,
  AccountContactFormKeys.COUNTRY_CODE,
]

export const getGovernmentIdPattern = (personRegions: string[]) => {
  const patternRegion = personRegions?.find(region =>
    Object.keys(GovernmentIdPattern)?.includes(region)
  )
  return patternRegion ? GovernmentIdPattern?.[patternRegion] : null
}

export const getIsValidPersonalIdNumber = (personalIdNumber: string, context: TestContext) => {
  const personRegions = PERSON_REGION_KEYS?.map(key => context?.parent?.[key])?.filter(Boolean)
  if (!personalIdNumber || !personRegions?.length) return true
  const validationPattern = getGovernmentIdPattern(personRegions)
  if (!validationPattern) return true
  const isValid = new RegExp(validationPattern).test(personalIdNumber)
  return (
    isValid ||
    context?.createError({
      message: getTranslation('formFields.personalIdentificationNumberPatternError'),
      path: AccountContactFormKeys.PERSONAL_IDENTIFICATION_NUMBER,
    })
  )
}
